import { EDIT_CUSTOMER_STATION_FAILT_SUCCESS, EDIT_CUSTOMER_STATION_FAILT_FAILED } from '../actions/types';

const initialState = {
    successMessage: "",
    errorMessage: ""
}

const editCustomerFault = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_CUSTOMER_STATION_FAILT_SUCCESS:
            return {
                ...state,
                successMessage: action.response.body.message
            }

        case EDIT_CUSTOMER_STATION_FAILT_FAILED:
            return {
                ...state,
                errorMessage: action.message
            }

        case 'CLEAR_STATE':
            return {
                ...state,
                errorMessage: '',
                successMessage: ''
            }

        default:
            return state
    }
}

export default editCustomerFault;